import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import QRCode from 'react-qr-code';
import { BoxIcon } from 'src/components';
import { SText } from 'src/components/SText';
import { generateCodeQrUrl } from 'src/helpers/scanner.config';
import { ColiWithHistoryPublicDataModelWithAgency } from 'src/types/public/public-data-model.types';
import { TrackingColiInfoHistoryViewer } from '../TrackingHistory/components/TrackingColiInfoHistoryViewer';

type Props = {
  testID?: string;
  isOpen: boolean;
  data: ColiWithHistoryPublicDataModelWithAgency;
  onSelect: (tracker: string) => void;
};

export const ColiWithHistoryPublic: React.FC<Props> = ({
  onSelect,
  isOpen,
  data,
  testID = 'ColiWithHistoryPublic',
}) => {
  const { t } = useTranslation();

  const onSelectHandler = useCallback(() => {
    onSelect(data.coli.tracker);
  }, [onSelect, data]);

  return (
    <div data-testid={testID} className="">
      <button
        className="px-4 py-3 rounded-md shadow-md bg-white my-2 bloc w-full justify-between text-left flex-row flex items-center"
        onClick={onSelectHandler}
      >
        <div className="flex justify-center items-center">
          <BoxIcon />
          <SText
            label="public.coli-number"
            classNames="text-md mx-2"
            translatingOptions={{ number: data.coli.tracker }}
          />
        </div>
        <div>
          <span className="text-primary text-2xl font-bold">{isOpen ? '-' : '+'}</span>
        </div>
      </button>

      {!!isOpen && (
        <>
          <div className="my-6 m-auto  self-center items-center justify-center flex">
            <div className="w-full">
              <TrackingColiInfoHistoryViewer data={data} />
            </div>
          </div>

          {data.coli.status === 'DELIVERED' && (
            <div className="mt-2 flex justify-center">
              <QRCode value={generateCodeQrUrl(data.coli.tracker)} size={200} />
            </div>
          )}
        </>
      )}
    </div>
  );
};
